import { render, staticRenderFns } from "./CityQuery.vue?vue&type=template&id=70d80d24&scoped=true&"
import script from "./CityQuery.vue?vue&type=script&lang=js&"
export * from "./CityQuery.vue?vue&type=script&lang=js&"
import style0 from "./CityQuery.vue?vue&type=style&index=0&id=70d80d24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d80d24",
  null
  
)

export default component.exports